<app-draggable-modal-wrapper>
    <form [formGroup]="form" class="flex flex-col gap-5 h-full">
        <mat-horizontal-stepper
            #stepper
            linear
            (selectionChange)="checkTemplateNameExistence.emit()"
            class="h-full"
        >
            <mat-step [stepControl]="form.controls.name">
                <ng-template matStepLabel>Template Information</ng-template>
                <div class="flex flex-col gap-3">
                    <div class="flex flex-col gap-3">
                        <span class="text-4xl text-primary-700 font-normal">
                            @if (isModification) {
                                Form 601 - Update Template Info
                            } @else {
                                Form 601 - New Template
                            }
                        </span>
                        <span class="text-primary-900 text-base font-medium">
                            Provide a template name and optional description to
                            begin.
                        </span>
                    </div>
                    <div class="flex flex-col gap-2">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Template Name</mat-label>
                            <input
                                #nameInput
                                title="Template Name"
                                matInput
                                formControlName="name"
                                maxLength="50"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                required
                            />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Description</mat-label>
                            <textarea
                                title="Description"
                                matInput
                                formControlName="description"
                                class="!resize-none"
                                maxLength="250"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                rows="4"
                            ></textarea>
                        </mat-form-field>
                    </div>
                    <div class="flex flex-row-reverse gap-5">
                        <button
                            type="button"
                            color="primary"
                            mat-button
                            mat-flat-button
                            (click)="onNextClick(stepper)"
                            [disabled]="!form.controls.name.valid"
                        >
                            Next
                        </button>
                        <button
                            mat-stroked-button
                            class="!border-primary-700"
                            color="primary"
                            type="button"
                            (click)="onCancelClick()"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>
                    @if (isOverwrite()) {
                        Confirm Template Overwrite
                    } @else if (isModification) {
                        Confirm Template Update
                    } @else {
                        Confirm Template Creation
                    }
                </ng-template>
                <div class="flex flex-col gap-3 h-full">
                    <div>
                        <span class="text-4xl text-primary-700 font-normal">
                            @if (isOverwrite()) {
                                Confirm Template Overwrite
                            } @else if (isModification) {
                                Confirm Template Update
                            } @else {
                                Confirm Template Creation
                            }
                        </span>
                    </div>
                    <div class="flex flex-col gap-5">
                        @if (isOverwrite()) {
                            <span class="text-error-700 text-base font-medium">
                                Warning: A template named "<strong>{{
                                    form.value.name
                                }}</strong
                                >" already exists in the system.
                            </span>
                            <span class="text-error-700 text-base font-medium">
                                Proceeding will overwrite the existing template
                                with this template. To preserve the existing
                                template, please return to the previous screen
                                and choose a different name.
                            </span>
                        } @else {
                            <span
                                class="text-primary-900 text-base font-medium"
                            >
                                @if (isModification) {
                                    You're about to update the template named
                                    "<strong>{{ form.value.name }}</strong
                                    >".
                                } @else {
                                    You're about to create a new template named
                                    "<strong>{{ form.value.name }}</strong
                                    >".
                                }
                            </span>
                            <span
                                class="text-primary-900 text-base font-medium"
                            >
                                Please review your template details carefully.
                                @if (isModification) {
                                    Proceeding will update the existing template
                                    with the new details.
                                } @else {
                                    Proceeding will create a new template with
                                    the provided details.
                                }
                                Click "Back" to make changes.
                            </span>
                        }
                    </div>
                    <div class="flex flex-row-reverse gap-5 pt-5 mt-auto">
                        <button
                            mat-button
                            mat-flat-button
                            type="submit"
                            color="primary"
                            [disabled]="form.invalid"
                            (click)="onSubmissionClick()"
                        >
                            @if (isOverwrite()) {
                                Overwrite
                            } @else if (isModification) {
                                Update
                            } @else {
                                Create
                            }
                        </button>
                        <button
                            mat-stroked-button
                            class="!border-primary-700"
                            color="primary"
                            type="button"
                            (click)="stepper.previous()"
                        >
                            Back
                        </button>
                        <button
                            mat-stroked-button
                            class="!border-primary-700"
                            color="primary"
                            type="button"
                            (click)="onCancelClick()"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </form>
</app-draggable-modal-wrapper>
